<div class="p-2 sm:p-4 bg-white rounded-xl sm:rounded-2xl shadow-lg w-full max-w-xs sm:max-w-md lg:max-w-2xl">
  <!-- Header -->
  <div class="flex items-center justify-between p-3 sm:p-6 border-b border-gray-200">
    <h2 class="text-lg sm:text-xl font-semibold text-gray-900 flex items-center">
      <mat-icon class="text-blue-600 mr-1 sm:mr-2 text-sm sm:text-base">filter_list</mat-icon>
      <span class="hidden sm:inline">Filter Parking Spaces</span>
      <span class="sm:hidden">Filters</span>
    </h2>
    <button mat-icon-button [mat-dialog-close]="" class="text-gray-400 hover:text-gray-600 transition-colors"
      aria-label="Close filter dialog">
      <mat-icon class="text-sm sm:text-base">close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div mat-dialog-content class="p-3 sm:p-6 max-h-80 sm:max-h-96 overflow-y-auto">
    <form [formGroup]="filterForm" class="space-y-2 sm:space-y-4" role="form" aria-label="Parking space filters">

      <!-- Name Filter -->
      <div>
        <mat-form-field appearance="fill" class="w-full text-sm">
          <mat-label class="text-sm">Parking Space Name</mat-label>
          <input matInput formControlName="name" placeholder="Search by name..." aria-describedby="name-hint"
            class="text-sm">
          <mat-hint id="name-hint" class="text-xs">Enter partial or full parking space name</mat-hint>
        </mat-form-field>
      </div>

      <!-- Type Filter -->
      <div>
        <mat-form-field appearance="fill" class="w-full text-sm">
          <mat-label class="text-sm">Parking Space Type</mat-label>
          <mat-select formControlName="type" aria-describedby="type-hint" class="text-sm">
            <mat-option value="">All Types</mat-option>
            @for (type of parkingSpaceTypes; track type.key) {
            <mat-option [value]="type.value">{{ type.label }}</mat-option>
            }
          </mat-select>
          <mat-hint id="type-hint" class="text-xs">Filter by parking space type</mat-hint>
        </mat-form-field>
      </div>

      <!-- Parking Zone ID Filter -->
      <div>
        <mat-form-field appearance="fill" class="w-full text-sm">
          <mat-label class="text-sm sm:text-base">Parking Zone ID</mat-label>
          <input matInput formControlName="parkingZoneId" placeholder="Enter zone ID" class="text-sm">
        </mat-form-field>
      </div>

      <!-- Infrastructure ID Filter -->
      <div>
        <mat-form-field appearance="fill" class="w-full text-sm">
          <mat-label class="text-sm sm:text-base">Infrastructure ID</mat-label>
          <input matInput formControlName="parkingSpaceInfrastructureId" placeholder="Enter infrastructure ID"
            class="text-sm">
        </mat-form-field>
      </div>

      <!-- Sort By Filter -->
      <div>
        <mat-form-field appearance="fill" class="w-full text-sm">
          <mat-label class="text-sm sm:text-base">Sort By</mat-label>
          <mat-select formControlName="sortBy" class="text-sm">
            <mat-option value="">Default</mat-option>
            @for (sortField of sortFields; track sortField.key) {
            <mat-option [value]="sortField.value">{{ sortField.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Sort Order Filter -->
      <div>
        <mat-form-field appearance="fill" class="w-full text-sm">
          <mat-label class="text-sm sm:text-base">Sort Order</mat-label>
          <mat-select formControlName="sortOrder" class="text-sm">
            <mat-option value="">Default</mat-option>
            @for (order of sortOrders; track order.key) {
            <mat-option [value]="order.value">{{ order.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </div>

  <!-- Actions -->
  <div mat-dialog-actions
    class="flex justify-between items-center p-3 sm:p-6 bg-gray-50 border-t border-gray-200 rounded-b-xl sm:rounded-b-2xl">
    <button mat-button type="button" (click)="clearFilters()"
      class="text-gray-600 hover:text-gray-800 transition-colors text-sm sm:text-base px-2 sm:px-4">
      Clear All
    </button>
    <button mat-raised-button color="primary" type="button" (click)="applyFilters()"
      class="shadow-sm text-sm sm:text-base px-3 sm:px-6">
      Apply Filters
    </button>
  </div>
</div>